export const filter = [
  {
      name: "3d",
      description: "Turning on 3d filter",
      type: 1
  },
  {
      name: "bass",
      description: "Turning on bass filter",
      type: 1
  },
  {
      name: 'bassboost',
      description: 'Turning on bassboost filter',
      type: 1,
      options: [
          {
              name: 'amount',
              description: 'The amount of the bassboost',
              type: 4,
          }
      ],
  },
  {
      name: "china",
      description: "Turning on china filter",
      type: 1
  },
  {
      name: "chipmunk",
      description: "Turning on chipmunk filter",
      type: 1
  },
  {
      name: "darthvader",
      description: "Turning on darthvader filter",
      type: 1
  },
  {
      name: "daycore",
      description: "Turning on daycore filter",
      type: 1
  },
  {
      name: "doubletime",
      description: "Turning on doubletime filter",
      type: 1
  },
  {
      name: "earrape",
      description: "Destroy your ear!",
      type: 1
  },
  {
      name: 'equalizer',
      description: 'Custom Equalizer!',
      type: 1,
      options: [
          {
              name: 'bands',
              description: 'Number of bands to use (max 14 bands.)',
              type: 3,
          }
      ],
  },
  {
      name: "nightcore",
      description: "Turning on nightcore filter",
      type: 1
  },
  {
      name: 'pitch',
      description: 'Sets the pitch of the song.',
      type: 1,
      options: [
          {
              name: 'amount',
              description: 'The amount of pitch to change the song by.',
              type: 4,
              required: true
          }
      ],
  },
  {
      name: "pop",
      description: "Turning on pop filter",
      type: 1
  },
  {
      name: "rate",
      description: "Sets the rate of the song.",
      type: 1,
      options: [
          {
              name: "amount",
              description: "The amount of rate to set.",
              type: 4,
              required: true,
          }
      ],
  },
  {
      name: "reset",
      description: "Reset filter",
      type: 1
  },
  {
      name: "slowmotion",
      description: "Turning on slowmotion filter",
      type: 1
  },
  {
      name: "soft",
      description: "Turning on soft filter",
      type: 1
  },
  {
      name: "speed",
      description: "Sets the speed of the song.",
      type: 1,
      options: [
          {
              name: "amount",
              description: "The amount of speed to set the song to.",
              type: 4,
              required: true,
          }
      ],
  },
  {
      name: "superbass",
      description: "Turning on superbass filter",
      type: 1
  },
  {
      name: "television",
      description: "Turning on television filter",
      type: 1
  },
  {
      name: "treblebass",
      description: "Turning on treblebass filter",
      type: 1
  },
  {
      name: "tremolo",
      description: "Turning on tremolo filter",
      type: 1
  },
  {
      name: "vaporwave",
      description: "Turning on vaporwave filter",
      type: 1
  },
  {
      name: "vibrate",
      description: "Turning on vibrate filter",
      type: 1
  },
  {
      name: "vibrato",
      description: "Turning on vibrato filter",
      type: 1
  }
]